/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// DO NOT MODIFY
// FILE GENERATED BY `intl-codegen@2.2.1`
// https://github.com/eversport/intl-codegen
// DO NOT MODIFY

export default context => {
  const formatter_0 = context.n({});
  const formatter_1 = context.m({});
  const formatter_2 = context.d({});

  return [
    // `apple-incomplete-profile`:
    // This Apple-profile is incomplete. It needs to have at least an e-mail address, first name and last name. Please use a different method of registration.
    params => "" +
      "This Apple-profile is incomplete. It needs to have at least an e-mail address, first name and last name. Please use a different method of registration.",

    // `booking-cancellation-not-allowed`:
    // Booking cancellation is not possible
    params => "" +
      "Booking cancellation is not possible",

    // `date-span`:
    // {from, date} - {until, date}
    params => "" +
      formatter_2(params.from) +
      " - " +
      formatter_2(params.until),

    // `days-from-until`:
    // {days} {from} - {until}
    params => "" +
      params.days +
      " " +
      params.from +
      " - " +
      params.until,

    // `Discount`:
    // Discount
    params => "" +
      "Discount",

    // `discount-and-special-offer-not-allowed`:
    // Vouchers can't be redeemed in combination with other discounts.
    params => "" +
      "Vouchers can't be redeemed in combination with other discounts.",

    // `discount-expired`:
    // This voucher has expired.
    params => "" +
      "This voucher has expired.",

    // `discount-marketing-discount-not-allowed-in-widget`:
    // Eversports discounts can just be redeemed directly on www.eversports.com.
    params => "" +
      "Eversports discounts can just be redeemed directly on www.eversports.com.",

    // `discount-marketing-without-online-booking`:
    // Eversports discounts can just be redeemed at venues with online payment.
    params => "" +
      "Eversports discounts can just be redeemed at venues with online payment.",

    // `discount-max-per-system`:
    // The limit for this voucher is exceeded.
    params => "" +
      "The limit for this voucher is exceeded.",

    // `discount-max-per-user`:
    // You have already redeemed this voucher {userUsageCount} times.
    params => "" +
      "You have already redeemed this voucher " +
      formatter_0(params.userUsageCount) +
      " times.",

    // `discount-min-price-not-reached`:
    // This voucher is redeemable from an amount of {minPrice}.
    params => "" +
      "This voucher is redeemable from an amount of " +
      formatter_1(params.minPrice) +
      ".",

    // `discount-mobile-discount-only`:
    // This voucher is only redeemable via the Eversports app.
    params => "" +
      "This voucher is only redeemable via the Eversports app.",

    // `discount-new-to-eversports-only`:
    // This voucher is just redeemable for new customers of Eversports.
    params => "" +
      "This voucher is just redeemable for new customers of Eversports.",

    // `discount-new-to-facility-only`:
    // This voucher is just redeemable for new venue customers.
    params => "" +
      "This voucher is just redeemable for new venue customers.",

    // `discount-once-per-device-only`:
    // This voucher can only be redeemed once per device.
    params => "" +
      "This voucher can only be redeemed once per device.",

    // `discount-wrong-court`:
    // This voucher can only be redeemed on the following courts: {courts}
    params => "" +
      "This voucher can only be redeemed on the following courts: " +
      params.courts,

    // `discount-wrong-currency`:
    // This voucher is not redeemable in this currency.
    params => "" +
      "This voucher is not redeemable in this currency.",

    // `discount-wrong-date`:
    // This voucher can only be redeemed on the following dates: {dates}
    params => "" +
      "This voucher can only be redeemed on the following dates: " +
      params.dates,

    // `discount-wrong-item-type`:
    // This voucher cannot be redeemed for this product.
    params => "" +
      "This voucher cannot be redeemed for this product.",

    // `discount-wrong-period`:
    // This voucher can just be redeemed at the following times: {periods}
    params => "" +
      "This voucher can just be redeemed at the following times: " +
      params.periods,

    // `discount-wrong-sport`:
    // This voucher can only be redeemed for the following sports: {sports}
    params => "" +
      "This voucher can only be redeemed for the following sports: " +
      params.sports,

    // `discount-wrong-user`:
    // This voucher is only valid for specific users.
    params => "" +
      "This voucher is only valid for specific users.",

    // `discount-wrong-venue`:
    // This voucher code can only be redeemed at the following venues: {venues}
    params => "" +
      "This voucher code can only be redeemed at the following venues: " +
      params.venues,

    // `email-provider-blocked`:
    // There seems to be an error with your email. Please try again later.
    params => "" +
      "There seems to be an error with your email. Please try again later.",

    // `event-in-the-past`:
    // This event has already been concluded.
    params => "" +
      "This event has already been concluded.",

    // `event-max-bookings-of-customergroup-reached`:
    // A maximum number of bookings, that are planned in the future, is specified for your customer group. You have already reached this. Please sign off of one of your future bookings in order to be able to make another booking. Otherwise you can only book again as soon as one of your future bookings is over.
    params => "" +
      "A maximum number of bookings, that are planned in the future, is specified for your customer group. You have already reached this. Please sign off of one of your future bookings in order to be able to make another booking. Otherwise you can only book again as soon as one of your future bookings is over.",

    // `event-max-participants-reached`:
    // The maximum number of participants has been reached.
    params => "" +
      "The maximum number of participants has been reached.",

    // `event-not-bookable`:
    // This event is not bookable online.
    params => "" +
      "This event is not bookable online.",

    // `event-registration-not-open`:
    // The registration is currently not possible.
    params => "" +
      "The registration is currently not possible.",

    // `event-restricted-for-user-clubgroup`:
    // Unfortunately, you are not eligible to participate.
    params => "" +
      "Unfortunately, you are not eligible to participate.",

    // `event-user-already-registered`:
    // You are already registered for this event.
    params => "" +
      "You are already registered for this event.",

    // `expired-token`:
    // Expired Token
    params => "" +
      "Expired Token",

    // `family-account-member-has-active-memberships-with-online-payment`:
    // As long as the memberships of this family member are not terminated, you cannot remove the family member from this account. Otherwise, you might be charged for future membership invoices, if the membership is extended.
    params => "" +
      "As long as the memberships of this family member are not terminated, you cannot remove the family member from this account. Otherwise, you might be charged for future membership invoices, if the membership is extended.",

    // `fieldname-email`:
    // Email address
    params => "" +
      "Email address",

    // `fieldname-first-name`:
    // first name
    params => "" +
      "first name",

    // `fieldname-last-name`:
    // last name
    params => "" +
      "last name",

    // `fieldname-password`:
    // password
    params => "" +
      "password",

    // `internal-server-error`:
    // An unexpected error happened. Please try again later.
    params => "" +
      "An unexpected error happened. Please try again later.",

    // `invalid-array`:
    // Invalid values
    params => "" +
      "Invalid values",

    // `invalid-credentials`:
    // Wrong email or password
    params => "" +
      "Wrong email or password",

    // `invalid-date`:
    // Invalid date
    params => "" +
      "Invalid date",

    // `invalid-email`:
    // The field {field, select,
    //   undefined {}
    //   other {'{field}'}
    // } must be a valid email address
    params => "" +
      "The field " +
      (
        params.field == "undefined" ? "" :
        "" +
          "'" +
          params.field +
          "'"
      ) +
      " must be a valid email address",

    // `invalid-fiscal-code`:
    // The Personal ID/Tax Number you entered is not valid.
    params => "" +
      "The Personal ID/Tax Number you entered is not valid.",

    // `invalid-iban`:
    // Invalid IBAN
    params => "" +
      "Invalid IBAN",

    // `invalid-id`:
    // Invalid ID
    params => "" +
      "Invalid ID",

    // `invalid-max-array-length`:
    // Just {max, plural,
    //   =1 {a maximum of one option can be marked}
    //   other {{max} options can be marked maximum}
    // }
    params => "" +
      "Just " +
      (
        params.max == 1 ? "" +
          "a maximum of one option can be marked" :
        "" +
          formatter_0(params.max) +
          " options can be marked maximum"
      ),

    // `invalid-max-length`:
    // The field {field, select,
    //   undefined {}
    //   other {'{field}'}
    // } {max, plural, one {}
    //   =1 {must be completed}
    //   other {must have a minimum length of {max} characters}
    // }
    params => "" +
      "The field " +
      (
        params.field == "undefined" ? "" :
        "" +
          "'" +
          params.field +
          "'"
      ) +
      " " +
      (
        context.p(params.max) == "one" ? "" :
        params.max == 1 ? "" +
          "must be completed" :
        "" +
          "must have a minimum length of " +
          formatter_0(params.max) +
          " characters"
      ),

    // `invalid-max-value`:
    // Invalid maximum value
    params => "" +
      "Invalid maximum value",

    // `invalid-min-array-length`:
    // At least {min, plural,
    //   =1 {one option has to be selected}
    //   other {{min} options have to be selected}
    // }
    params => "" +
      "At least " +
      (
        params.min == 1 ? "" +
          "one option has to be selected" :
        "" +
          formatter_0(params.min) +
          " options have to be selected"
      ),

    // `invalid-min-length`:
    // The field {field, select,
    //   undefined {}
    //   other {'{field}'}
    // } {min, plural, one {}
    //   =1 {must be completed}
    //   other {must have a minimum length of {min} characters}
    // }
    params => "" +
      "The field " +
      (
        params.field == "undefined" ? "" :
        "" +
          "'" +
          params.field +
          "'"
      ) +
      " " +
      (
        context.p(params.min) == "one" ? "" :
        params.min == 1 ? "" +
          "must be completed" :
        "" +
          "must have a minimum length of " +
          formatter_0(params.min) +
          " characters"
      ),

    // `invalid-min-value`:
    // Invalid minimum value
    params => "" +
      "Invalid minimum value",

    // `invalid-number`:
    // Invalid number
    params => "" +
      "Invalid number",

    // `invalid-offer-for-event`:
    // The selected product cannot be used for this booking.
    params => "" +
      "The selected product cannot be used for this booking.",

    // `invalid-password`:
    // The field {field, select,
    //   undefined {}
    //   other {'{field}'}
    // } must have a minimum length of 8 characters
    params => "" +
      "The field " +
      (
        params.field == "undefined" ? "" :
        "" +
          "'" +
          params.field +
          "'"
      ) +
      " must have a minimum length of 8 characters",

    // `invalid-phone`:
    // The field {field, select,
    //   undefined {}
    //   other {'{field}'}
    // } must be a valid phone number
    params => "" +
      "The field " +
      (
        params.field == "undefined" ? "" :
        "" +
          "'" +
          params.field +
          "'"
      ) +
      " must be a valid phone number",

    // `invalid-token`:
    // Invalid Token
    params => "" +
      "Invalid Token",

    // `match-already-cancelled`:
    // Match is already cancelled
    params => "" +
      "Match is already cancelled",

    // `match-has-no-open-spots-left`:
    // The match is already full
    params => "" +
      "The match is already full",

    // `match-invalid-comment`:
    // Please provide a valid text (remove HTML, Javascript, etc.)
    params => "" +
      "Please provide a valid text (remove HTML, Javascript, etc.)",

    // `match-long-comment`:
    // The comment is too long!
    params => "" +
      "The comment is too long!",

    // `match-long-note`:
    // The text is too long!
    params => "" +
      "The text is too long!",

    // `match-max-participants-must-be-bigger-than-or-equal-to-existing-participants`:
    // Maximum number of participants must be bigger than or equal to number of existing participants
    params => "" +
      "Maximum number of participants must be bigger than or equal to number of existing participants",

    // `match-max-participants-must-be-positive`:
    // Maximum number of participants must be a positive number
    params => "" +
      "Maximum number of participants must be a positive number",

    // `match-min-participants-must-be-positive`:
    // Minimum number of participants must be a positive number
    params => "" +
      "Minimum number of participants must be a positive number",

    // `match-missing-fields`:
    // Please fill out all required fields
    params => "" +
      "Please fill out all required fields",

    // `match-no-fields-to-update`:
    // Please adapt at least one field to update the match
    params => "" +
      "Please adapt at least one field to update the match",

    // `min-age-14-years`:
    // The minimum age for using Eversports is 14 years.
    params => "" +
      "The minimum age for using Eversports is 14 years.",

    // `online-booking-or-purchase-not-enabled`:
    // Currently, the venue is not allowing online bookings
    params => "" +
      "Currently, the venue is not allowing online bookings",

    // `product-invalid-event`:
    // This product cannot be used for this event
    params => "" +
      "This product cannot be used for this event",

    // `product-new-customers-only`:
    // This product can only be purchased by new customers of this venue.
    params => "" +
      "This product can only be purchased by new customers of this venue.",

    // `product-no-aggregator-spots`:
    // The maximum number of spots that can be booked with this pass has been reached
    params => "" +
      "The maximum number of spots that can be booked with this pass has been reached",

    // `product-no-trial-spots`:
    // The maximum number of spots that can be booked with this pass has been reached
    params => "" +
      "The maximum number of spots that can be booked with this pass has been reached",

    // `product-not-sold-online`:
    // Purchase not possible.
    params => "" +
      "Purchase not possible.",

    // `product-not-valid-at-facility`:
    // This product is not valid at this venue.
    params => "" +
      "This product is not valid at this venue.",

    // `product-once-per-customers-only`:
    // This product can only be bought once per customer.
    params => "" +
      "This product can only be bought once per customer.",

    // `product-recording-already-sold`:
    // You've already purchased this video.
    params => "" +
      "You've already purchased this video.",

    // `product-selected-customer-groups-only`:
    // This product is only available to selected customer groups.
    params => "" +
      "This product is only available to selected customer groups.",

    // `product-validity-expired`:
    // This product is expired
    params => "" +
      "This product is expired",

    // `product-validity-expires-before-event`:
    // This product will be expired by the time of the booking
    params => "" +
      "This product will be expired by the time of the booking",

    // `product-validity-failed-payments`:
    // The recurring payment for this membership has failed
    params => "" +
      "The recurring payment for this membership has failed",

    // `product-validity-invalid-event`:
    // This product cannot be used for this event
    params => "" +
      "This product cannot be used for this event",

    // `product-validity-invalid-recording`:
    // This product cannot be used for this video
    params => "" +
      "This product cannot be used for this video",

    // `product-validity-max-cycle-exhausted`:
    // The maximum number of bookings for this period has already been used
    params => "" +
      "The maximum number of bookings for this period has already been used",

    // `product-validity-membership-paused`:
    // This membership is paused at the time of the event
    params => "" +
      "This membership is paused at the time of the event",

    // `product-validity-not-yet-valid`:
    // This product is not valid at the time of the booking
    params => "" +
      "This product is not valid at the time of the booking",

    // `product-validity-total-limit-exhausted`:
    // All units of this pass have been used up
    params => "" +
      "All units of this pass have been used up",

    // `required`:
    // This field is required
    params => "" +
      "This field is required",

    // `This-voucher-code-is-not-valid-at-Eversports`:
    // This voucher code is not valid at Eversports.
    params => "" +
      "This voucher code is not valid at Eversports.",

    // `ticket-event-no-tickets-available`:
    // There are no tickets available for this activity.
    params => "" +
      "There are no tickets available for this activity.",

    // `user-with-email-exists`:
    // A user with this email already exists.
    params => "" +
      "A user with this email already exists.",

    // `voucher-without-product-not-allowed`:
    // A product must first be selected in order to apply a voucher.
    params => "" +
      "A product must first be selected in order to apply a voucher.",
  ];
};
